import React, { useState } from 'react'
import PersonIcon from '../Logos/person.svg'
import '../Style/UserSectionSelector.css'
import { useParams } from 'react-router-dom'
import ImageAddIcon from '../Logos/image-add.svg'
import UserProfile from '../Profile_Pictures/1662741205554.jpg'
import UploadIcon from '../Logos/upload.svg'
import WarningIcon from '../Logos/alert-error.svg'
import EmailIcon from '../Logos/envelope.svg'
import PhoneIcon from '../Logos/phone.svg'
import AddressIcon from '../Logos/map.svg'
import LockIcon from '../Logos/lock (1).svg'
import OpenEyeIcon from '../Logos/eye.svg'
import CloseEyeIcon from '../Logos/eye-off.svg'


function UserSectionSelector() {
    const { Section } = useParams()
    const [ShowingPassword, SetShowingPassword] = useState(false)
    return (
        <>
            {!Section || Section === "public-info" ? <form className='user-settings-selector-container'>
                <div className='information'>
                    <img src={WarningIcon} />
                    توجه داشته باشید برای اعمال تغییرات، بعد از تغییرات بر روی دکمه اعمال تغییرات در پایین صفحه کلیک کنید</div>
                <div className='username-settings-container'>
                    <div className='title'>تنظیمات نام کاربری</div>
                    <div className='username-input-container'>
                        <img src={PersonIcon} />
                        <input type='text' name='username' placeholder='نام کاربری جدید خود را وارد کنید...' />
                    </div>
                </div>
                <div className='profile-picture-container'>
                    <div className='title'>عکس پروفایل</div>
                    <div style={{ backgroundImage: `url(${UserProfile})` }} className='profile-picture-input-container'>
                        <input type='file' />
                        <div className='upload-icon' style={{ backgroundImage: `url(${UploadIcon})` }}></div>
                    </div>
                </div>
                <button type='submit' className='save-changes-button'>اعمال تغییرات</button>
            </form> : null}

            {Section === "personal-info" ? <form className='user-settings-selector-container'>
                <div className='information'>
                    <img src={WarningIcon} />
                    توجه داشته باشید برای اعمال تغییرات، بعد از تغییرات بر روی دکمه اعمال تغییرات در پایین صفحه کلیک کنید</div>
                <div className='full-name-container'>
                    <div className='title'>نام و نام خانوادگی</div>
                    <div className='first-name-input-container'>
                        <input type='text' name='first_name' placeholder='نام کوچک...' />
                    </div>
                    <div className='last-name-input-container'>
                        <input type='text' name='last_name' placeholder='نام خانوادگی... (اختیاری)' />
                    </div>
                </div>
                <div className='email-container'>
                    <div className='title'>ایمیل</div>
                    <div className='email-input-container'>
                        <img src={EmailIcon} />
                        <input type='email' name='email' placeholder='ایمیل...' />
                    </div>
                </div>
                <div className='phone-num-container'>
                    <div className='title'>شماره تلفن</div>
                    <div className='phone-num-input-container'>
                        <img src={PhoneIcon} />
                        <input type='tel' name='phone_number' placeholder='شماره تلفن...' />
                    </div>
                </div>
                <button type='submit' className='save-changes-button'>اعمال تغییرات</button>
            </form> : null}

            {Section === "address" ? <form className='user-settings-selector-container'>
                <div className='information'>
                    <img src={WarningIcon} />
                    توجه داشته باشید برای اعمال تغییرات، بعد از تغییرات بر روی دکمه اعمال تغییرات در پایین صفحه کلیک کنید</div>
                <div className='ostan-container'>
                    <div className='title'>استان</div>
                    <div className='ostan-input-container'>
                        <select className='ostan-input'>
                            <option value={"Tehran"}>تهران</option>
                            <option value={"Gilan"}>گیلان</option>
                            <option value={"Mazandaran"}>مازندران</option>
                        </select>
                    </div>
                </div>
                <div className='address-container'>
                    <div className='title'>ادرس پستی</div>
                    <div className='address-input-container'>
                        <img src={AddressIcon} />
                        <input type='text' name='address_input' placeholder='ادرس پستی...' />
                    </div>
                </div>
                <div className='address-code-container'>
                    <div className='title'>کد پستی</div>
                    <div className='address-code-input-container'>
                        <input type='text' name='address_code_input' placeholder='کد پستی...' />
                    </div>
                </div>
                <button type='submit' className='save-changes-button'>اعمال تغییرات</button>
            </form> : null}

            {Section === "security" ? <form className='user-settings-selector-container'>
                <div className='information'>
                    <img src={WarningIcon} />
                    توجه داشته باشید برای اعمال تغییرات، بعد از تغییرات بر روی دکمه اعمال تغییرات در پایین صفحه کلیک کنید</div>
                <div className='password-container'>
                    <div className='title'>رمز عبور</div>
                    <div className='password-inputs-container'>
                        <div className='current-password-container'>
                            <img src={LockIcon} className='lock-icon' />
                            <input type='password' name='current_password_input' placeholder='رمز فعلی (اگر رمزی ندارید این بخش رو خالی بزارید)...' />
                            <div className='show-password-button'>
                                <img src={ShowingPassword ? OpenEyeIcon : CloseEyeIcon} className='show-password-icon' />
                            </div>
                        </div>
                        <div className='new-password-container'>
                            <img src={LockIcon} className='lock-icon' />
                            <input type='password' name='new_password_input' placeholder='رمز جدید...' />
                            <div className='show-password-button'>
                                <img src={ShowingPassword ? OpenEyeIcon : CloseEyeIcon} className='show-password-icon' />
                            </div>
                        </div>
                        <div className='repeat-new-password-container'>
                            <img src={LockIcon} className='lock-icon' />
                            <input type='password' name='repeat-new_password_input' placeholder='تکرار رمز جدید...' />
                            <div className='show-password-button'>
                                <img src={ShowingPassword ? OpenEyeIcon : CloseEyeIcon} className='show-password-icon' />
                            </div>
                        </div>
                    </div>
                </div>
                <button type='submit' className='save-changes-button'>اعمال تغییرات</button>
            </form> : null}
        </>
    )
}

export default UserSectionSelector